import _ from "lodash";
import {MatterDocument} from "common/types/matter";
import renderProcessingUploadedDocumentStatus from "common_components/render_processing_document_status";
import React from "react";
import isMatterDocumentComplete from "../utils/is_matter_document_uploading";

interface UploadStatusProps {
  matterDocument: MatterDocument;
  displayInDocDetail: boolean;
}

const styles = {
  phaseMessage: displayInDocDetail =>
    ({
      fontSize: displayInDocDetail ? "0.75em" : "1em",
      textAlign: displayInDocDetail ? "left" : "center",
      color: "rgb(85, 68, 68)",
    } as React.CSSProperties),
  timeEstimateMessage: displayInDocDetail =>
    ({
      fontSize: "0.75em",
      textAlign: displayInDocDetail ? "left" : "center",
      color: "rgb(85, 68, 68)",
    } as React.CSSProperties),
};

export default function UploadStatus({
  matterDocument,
  displayInDocDetail,
}: UploadStatusProps) {
  if (isMatterDocumentComplete(matterDocument)) {
    return <></>;
  }

  const uploadStatusKeys =
    matterDocument.concat_load_state[0] === null
      ? {}
      : matterDocument.upload_status;

  return (
    <span style={{width: "100%"}}>
      {renderProcessingUploadedDocumentStatus(
        {
          ..._.omit(matterDocument, "upload_status"),
          file_extension: "docx", // TODO
          concat_filenames: [matterDocument],
          ...uploadStatusKeys,
          llm_issue_task_counts: matterDocument.issue_task_counts,
        },
        {
          phaseMessage: styles.phaseMessage(displayInDocDetail),
          timeEstimateMessage: styles.timeEstimateMessage(displayInDocDetail),
        },
      )}
    </span>
  );
}
